<ws-select
	[options]="countries"
	[(result)]="result"
	(resultChange)="onResultChange($event)"
	display="name"
	[value]="valueField"
	[optionTranslate]="!!translateModule"
	[translateModule]="translateModule"
	[label]="label"
	[placeholder]="placeholder"
	[disabled]="disabled"
	[required]="required"
	[readonly]="readonly"
	[validationConstraints]="validationConstraints"
	[errors]="errors"
	[model]="model"
	[property]="property"
></ws-select>
